import React, { PropTypes } from 'react';
import classnames from 'classnames';

const Toggle = ({ disabled, onToggle, toggled }) => {
    let classes = classnames({
        'toggle': true,
        toggled
    });

    return (<div className={classes} onClick={ () => !disabled && onToggle() }></div>);
};

Toggle.propTypes = {
    disabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    toggled: PropTypes.bool.isRequired
};
Toggle.defaultProps = {
    disabled: false
};

export default Toggle;


// WEBPACK FOOTER //
// ./src/components/toggle/index.js